import React from "react";
import {
  Card,
  List,
  Image,
  Grid,
} from "semantic-ui-react";


const BookingInfo = ({ serviceName, location, date, time }) => {
  return (
    <Grid.Column style={{ maxWidth: 450, padding: "1rem" }}>
      <Card.Group className="centered">
        <Card>
          <Card.Content>
            <Image
              floated="right"
              size="mini"
              src={require("./../../../images/hero-image-app.jpg")}
            />
            <Card.Header>{serviceName}</Card.Header>
            <Card.Meta>{location}</Card.Meta>
            <Card.Description>
              <List  divided >
                <List.Item><List.Content floated="left">Date:<strong>{date} </strong>| Time: <strong>{time}</strong></List.Content></List.Item>
              
               
              </List>
            </Card.Description>
          </Card.Content>
        </Card>
      </Card.Group>
    </Grid.Column>
  );
};

export default BookingInfo;
